import { render, staticRenderFns } from "./MzLabyrinth.vue?vue&type=template&id=442d4100&scoped=true&"
import script from "./MzLabyrinth.vue?vue&type=script&lang=js&"
export * from "./MzLabyrinth.vue?vue&type=script&lang=js&"
import style0 from "./MzLabyrinth.vue?vue&type=style&index=0&id=442d4100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442d4100",
  null
  
)

export default component.exports